import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useInventoryStore } from '../../store/inventoryStore'
import { createCategory } from '../../utils/createCategory'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useAddCategoryMutation = (onSuccess?: () => void) => {
  const addCategory = useInventoryStore((state) => state.addCategory)

  return useMutation({
    mutationFn: createCategory,
    onSuccess: ({ message, category }) => {
      addCategory(category)
      toast.success(message || 'Category created successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(
        error,
        'An error occurred while creating the category.',
      )
    },
  })
}
